import { Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SlideToggle } from '../slide-toggle/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-general-page-header',
  imports: [TranslateModule, MatIconModule, SlideToggle],
  templateUrl: './general-page-header.component.html',
  styleUrl: './general-page-header.component.scss',
})
export class GeneralPageHeaderComponent {
  readonly pageTitle = input.required<string>();
  readonly numberOfTheElements = input<number>();
  readonly showBack = input<boolean>(false);

  readonly showToggle = input<boolean>(false);
  readonly defaultToggleState = input<boolean>(false);
  readonly toggleLabels = input<{ labelFalse: string; labelTrue: string } | undefined>(undefined);

  goBack = output<void>();
  onToggleSlide = output<boolean>();
}
